<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Model" title="Models" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-10 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Manage Models</span>
									</div>
									<div class="col-md-2">
										<!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
										<!-- <div class="btn btn-primary">Add Model</div> -->
										<button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Model</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6">
										<label class="d-flex listing-length"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchModels()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-3">
										<!-- <div class="dropdown">
												<button class="dropbtn btn-primary" type="button">All Brands <span><i class="icofont icofont-arrow-down"></i></span></button>
												<div class="dropdown-content"><a href="#">Action</a><a href="#">Another Action</a><a href="#">Something Else Here</a></div>
											</div> -->
											<select class="form-select" v-model="brand_id" @change="fetchModels()">
												<option :value="null">All Categories</option>
                                 				<option :value="brand.id" v-for="brand in brands" :key="brand.id">{{brand.brand_name}}</option>
											</select>
									</div>
									<div class="col-md-3">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchModels()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Name</th>
											<th>Brand</th>
											<th>Status</th>
											<th>Options</th>
											<!-- <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-sort="ascending" aria-label="Name: activate to sort column descending"
												style="width: 415.266px;">Name</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Brand: activate to sort column ascending"
												style="width: 337.797px;">Brand</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Status: activate to sort column ascending"
												style="width: 337.797px;">Status</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Options: activate to sort column ascending"
												style="width: 337.266px;">Options</th>	 -->
										</tr>
									</thead>
									<tbody v-if="Boolean(models.length)">
										<tr v-for="model in models" :key="model.id">
											<td>{{ model.name }}</td>
										<td>{{ model.brand_name }}</td>
										<td>
											<label v-if="model.status == 1">Active</label>
											<label v-else>Blocked</label>
										</td>
										<td>
											<a class="btn btn-primary mt-2 me-1 btn-sm" @click="editUser(model)">Edit</a>

											<a class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateUser(model)" v-if="model.status == 1">Deactivate</a>
											<a class="btn btn-success mt-2 me-1 btn-sm" @click="activateUser(model)" v-else>Activate</a>
										</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchModels(page.url + '&limit=' + listing_length + '&type=0' + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->

						</div>
						
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Add Model">
			<template #body>
				<form @submit.prevent="addModel" enctype="multipart/form-data" @hidden="clearForm()">
					<div class="col-md-12 form-group">
						<label class="control-label">Model name <span class="required">*</span></label>
						<input class="form-control" type="text" placeholder="" v-model="model.model_name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
						<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Brand <span class="required">*</span></label>
						<select class="form-control" v-model="model.brand_id" v-bind:class="{ 'is-invalid': Boolean(errors.brand_id) }">
							<option :value="null" disabled>-- Select brand --</option>
							<option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.brand_name }}</option>
						</select>
						<div v-for="(val, index) in errors.brand_id" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 mt-3 form-group">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		
	</div>
</template>

<script>

import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "ModelsPage",
		components: {
			DynamicModal
		},

		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {
			return {
				models: [],
				brands: [],
				model: {
					id: null,
					model_name: "",
					brand_id: null,
					id_brand: "",
				},
				modal_title: "Add Model",
				button_title: "Add",
				pagination: {},
				edit: false,
				model_status: {
					id: "",
					status: "",
				},
				brand_id: null,
				id_brand: "",
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				activate: false,
         		deactivate: false,
         		active_page_url: null,
			};
		},
		mounted() {
			
		},

		created() {
			this.fetchModels();
			this.fetchBrands();
		},

		methods: {
			fetchModels(page_url = null) {
				if (this.brand_id) {
					this.id_brand = this.brand_id;
				} else {
					this.id_brand = "";
				}
				let url = "/api/admin/models?limit=" + this.listing_length + "&type=0&keyword=" + this.keyword + "&brand_id=" + this.id_brand;
				if (page_url) {
					page_url = page_url + "&brand_id=" + this.id_brand;
				}
				page_url = page_url || url;

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.models = responseData.data;
						this.pagination = responseData.links;
						console.log(this.models);
						console.log(this.pagination);
					})
					.catch((err) => console.log(err));
			},

			fetchBrands() {
				this.getToken();
				this.$axios
					.get("/api/admin/models/brands", {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data;
						this.brands = responseData.data;
						console.log(this.brands);
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },
			addModel() {
				this.getToken();
				let formData = new FormData();
				formData.append("name", this.model.model_name);
				if (this.model.brand_id) {
					this.model.id_brand = this.model.brand_id;
				} else {
					this.model.id_brand = "";
				}
				formData.append("brand_id", this.model.id_brand);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/admin/models/add";
					this.active_page_url = null;
				} else {
					url = "/api/admin/models/edit";
					formData.append("model_id", this.model.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchModels(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);

						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			editUser(model) {
				this.edit = true;
				this.model.id = model.id;
				this.model.model_name = model.name;
				this.model.brand_id = model.brand_id;
				this.errors = {};
				this.modal_title = "Edit Model";
				this.button_title = "Update";
				this.showModal();
			},
			clearForm() {
				this.edit = false;
				this.model.id = null;
				this.model.model_name = "";
				this.model.brand_id = null;
				this.modal_title = "Add Model";
				this.button_title = "Add";
				this.errors = {};
			},
			activateUser(model) {
				this.activate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this brand?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.model_status.id = model.id;
						this.model_status.status = "1";
						this.updateModelStatus();
					}
					
				});
			},
			deactivateUser(model) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this user?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.model_status.id = model.id;
						this.model_status.status = "0";
						this.updateModelStatus();
					}
				});
			},
			updateModelStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/models/status?model_id=" + this.model_status.id + "&status=" + this.model_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchModels(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
		},
	};
</script>

